/* eslint-disable no-magic-numbers */
import React from 'react'

import Select from '../Select'

import { PaginationItemsPerPageWrapper, ItemsPerPageText, ItemsPerPageDropdownWrapper } from './style'
import { FormattedMessage } from 'react-intl'


const itemsPerPageOptions = [
  { label: 12, value: 12 },
  { label: 24, value: 24 },
  { label: 48, value: 48 }
]

const alternativeItemsPerPageOptions = [
  { label: 10, value: 10 },
  { label: 12, value: 12 },
  { label: 24, value: 24 },
  { label: 48, value: 48 }
]

const ItemsPerPageDropdown = ({ currentPage, resultsPerPage, totalNumber, onChange, dataTest, menuPlacement, alternativeOptions = false }) => {
  return (
    <PaginationItemsPerPageWrapper data-testid='test-items-per-page-wrapper' data-test={dataTest}>
      <ItemsPerPageText><FormattedMessage id='showing' /></ItemsPerPageText>
      <ItemsPerPageDropdownWrapper>
        <Select
          field="itemsPerPage"
          value={{value: resultsPerPage, label:resultsPerPage }}
          onChange={onChange}
          options={alternativeOptions ? alternativeItemsPerPageOptions : itemsPerPageOptions}
          marginTop="0px"
          placeholder="8"
          height="32px"
          indicatorSize='small'
          menuPlacement={menuPlacement}
        />
      </ItemsPerPageDropdownWrapper>
      <ItemsPerPageText>
        {currentPage * resultsPerPage - resultsPerPage + 1} - {(currentPage * resultsPerPage > totalNumber)? totalNumber : currentPage * resultsPerPage}
      </ItemsPerPageText>
      <ItemsPerPageText>&nbsp;of&nbsp;</ItemsPerPageText>
      <ItemsPerPageText>{totalNumber} Results</ItemsPerPageText>
    </PaginationItemsPerPageWrapper>
  )
}

export default ItemsPerPageDropdown
